module.exports = __webpack_public_path__ + "static/media/janbrolsma.c1f68c8c.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/janbrolsma.webp
// module id = 426
// module chunks = 0